'use strict';
import classNames from 'classnames';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {I18nMessage} from '../../../components/I18nMessage';
import {FilterInput} from '../../../components/lists/FilterInput';
import {UserLayout} from '../../../components/views/UserLayout';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {UserHome} from '../../../priorities/components/UserHome';


function BaseUserViewHomeView(props) {
  return (
    <UserLayout
      className={classNames("UserViewHome", props.className)}
      title={<I18nMessage message="user.views.home.label" />}
      filterComponent={(
        <FilterInput
          showFilterOptions={true}
          searchOnly={false}
          filterModalOptions={props.filterModalOptions}
          onChangeDebounce={450}

          onFilterChange={props.onFilterChange}
          onFilterOptionsUpdate={props.onFilterOptionsUpdate}
          onSortOptionsUpdate={props.onSortOptionsUpdate}
        />
      )}
      headerRightContent={(
        <Fragment>
          <div className="UserViewHome__desktopButtons">
            <Button
              className="UserViewHome__headerButton"
              activeClassName="UserViewHome__headerButton_active"
              iconClass="swift-sweep"
              onClick={props.onClickSweep}
              title={props.sweepIconTitle}
            />

            {props.canExport ? (
              <Button
                className="UserViewHome__headerButton"
                activeClassName="UserViewHome__headerButton_active"
                iconClass="ion-ios-download"
                title={props.exportIconTitle}
                onClick={props.onClickExport}
              />
            ) : null}
          </div>
        </Fragment>
      )}
      mode={props.mode}
      onLoadMore={noop}
    >
      <Fragment>
        <div className="UserViewHome__mobileButtons">
          <Button
            className="UserViewHome__headerButton"
            activeClassName="UserViewHome__headerButton_active"
            iconClass="swift-sweep"
            onClick={props.onClickSweep}
            title={props.sweepIconTitle}
          />

          {props.canExport ? (
            <Button
              className="UserViewHome__headerButton"
              activeClassName="UserViewHome__headerButton_active"
              iconClass="ion-ios-download"
              title={props.exportIconTitle}
              onClick={props.onClickExport}
            />
          ) : null}
        </div>
        <UserHome
          transitionGroupClass="UserLayout__content__container"
          itemClassName="UserLayout__content__item"
          {...props}
        />
      </Fragment>
    </UserLayout>
  );
}

BaseUserViewHomeView.propTypes = {
  className: T.string,

  hideTitle: T.string.isRequired,
  showTitle: T.string.isRequired,
  pinsTitle: T.string.isRequired,
  todoMessagesTitle: T.string.isRequired,
  todoMessagePlaceholder: T.string.isRequired,
  timersTitle: T.string.isRequired,
  prioritiesTitle: T.string.isRequired,
  prioritiesPlaceholderTitle: T.string.isRequired,
  radarPlaceholder: T.string.isRequired,
  sweepIconTitle: T.string.isRequired,
  exportIconTitle: T.string.isRequired,
  thisMonthLabel: T.string.isRequired,
  unscheduledMonthLabel: T.string.isRequired,
};

export const UserViewHomeView = I18nComponent(BaseUserViewHomeView, [
  {code: 'icon.hide.title', prop: 'hideTitle'},
  {code: 'icon.show.title', prop: 'showTitle'},
  {code: 'user.home.todoMessages', prop: 'todoMessagesTitle'},
  {code: 'user.home.todoMessages.placeholder', prop: 'todoMessagePlaceholder'},
  {code: 'user.home.timers', prop: 'timersTitle'},
  {code: 'user.home.pins', prop: 'pinsTitle'},
  {code: 'user.home.priorities', prop: 'prioritiesTitle'},
  {code: 'user.home.priorities.placeholder', prop: 'prioritiesPlaceholderTitle'},
  {code: 'user.home.radar.placeholder', prop: 'radarPlaceholder'},
  {code: 'user.home.this.month.label', prop: 'thisMonthLabel'},
  {code: 'user.home.unscheduled.month.label', prop: 'unscheduledMonthLabel'},
  {code: 'icon.sweep.title', prop: 'sweepIconTitle'},
  {code: 'icon.export.tasks.title', prop: 'exportIconTitle'},
  {code: 'default.button.load.more.label', prop: 'loadMoreLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewHome/UserViewHomeView.js